import { render, staticRenderFns } from "./RejectMultiCreate.vue?vue&type=template&id=5d6e45bd&scoped=true&"
import script from "./RejectMultiCreate.vue?vue&type=script&lang=js&"
export * from "./RejectMultiCreate.vue?vue&type=script&lang=js&"
import style0 from "./RejectMultiCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6e45bd",
  null
  
)

export default component.exports